<template>
  <div class="login">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label prop="instition">
        <el-input
          v-if="flag1"
          v-model="ruleForm.instition"
          placeholder="姓名"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          v-model="ruleForm.instition"
          placeholder="姓名"
          @blur="getName()"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="contactTel">
        <el-input
          v-if="flag2"
          v-model="ruleForm.contactTel"
          placeholder="手机号"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          v-model="ruleForm.contactTel"
          placeholder="手机号"
          @blur="getTel()"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="identifyCode">
        <el-input
          v-if="flag3"
          class="code_txt"
          v-model="ruleForm.identifyCode"
          placeholder="手机验证码"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          class="code_txt"
          v-model="ruleForm.identifyCode"
          placeholder="手机验证码"
          @blur="getIdentifycode()"
        ></el-input>
        <div class="phone_code" @click="disabledButton" v-if="isShow">
          <el-button :disabled="disabled">
            <span>发送验证码</span>
          </el-button>
        </div>
        <div class="phone_code1" v-else>
          <el-button :disabled="disabled">
            <span>{{ timeNum }}</span>
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label prop="password">
        <el-input
          v-if="flag4"
          type="password"
          v-model="ruleForm.password"
          placeholder="密码"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          type="password"
          v-model="ruleForm.password"
          placeholder="密码"
          @blur="getPassword()"
        ></el-input>
      </el-form-item>
      <el-form-item class="sub_button">
        <el-button
          class="button_login"
          :disabled="isTrue"
          :class="{ buttonColor: buttonColor }"
          :type="buttonColor == true ? 'primary' : 'info'"
          @click="submitForm('ruleForm')"
          >注册</el-button
        >
      </el-form-item>

      <el-form-item class="agreement_check clearfix" prop="checked">
        <div class="public_style agreement_content">
          <el-checkbox @change="isClick" v-model="checked"
            >我已同意相关</el-checkbox
          >
          <span @click="agreement">平台协议</span>
        </div>
        <div class="public_style registration">
          <span @click="directLogin('ruleForm')">直接登录</span>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  ApiRegister, //机构注册
  ApiTelCode, //获取手机验证码
  // ApiIsTelCode // 判断验证是否有效
} from "@/common/js/api.js";
export default {
  props: ["reset"],
  name: "Report",
  data() {
    var userphoneRule = (rule, value, callback) => {
      let p =
        /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
      if (!value) {
        this.sendCode = false;
        callback(new Error("手机号格式不正确"));
      } else {
        if (p.test(value) == true) {
          this.sendCode = true;
          callback();
        } else {
          this.sendCode = false;
          callback(new Error("手机号格式不正确"));
        }
      }
    };
    return {
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      timeNum: 60,
      timer: null,
      disabled: false, // 计时器是否可点击
      isShow: true, // 发送验证码按钮是否显示
      buttonColor: false, // 登录按钮颜色
      isTrue: true, // 登录按钮是否可用
      checked: false,
      sendCode: false,
      ruleForm: {
        // 法定代表人姓名
        instition: "",
        // 手机号
        contactTel: "",
        // 手机验证码
        identifyCode: "",
        // password
        password: "",
        // 手机验证码
        telCode: "",
        useType: 2,
      },
      rules: {
        instition: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        contactTel: [
          {
            required: true,
            validator: userphoneRule,
            trigger: "blur",
          },
        ],
        identifyCode: [
          {
            required: true,
            message: "请输入手机验证码",
            trigger: "blur",
          },
          {
            max: 6,
            message: "长度为6个字符",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.query.TownCode) {
      this.ruleForm.preFtCode = this.$route.query.TownCode;
      this.ruleForm.ftCode = this.$route.query.TownCode;
    }
  },
  methods: {
    getName() {
      this.flag1 = true;
    },
    getTel() {
      this.flag2 = true;
    },
    getIdentifycode() {
      this.flag3 = true;
    },
    getPassword() {
      this.flag4 = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async onSubmit() {
      this.ruleForm.password = this.$md5(this.ruleForm.password);

      console.log("this.$route.query.TownCode", this.$route.query.TownCode);
      let res = await ApiRegister(this.ruleForm);
      if (res.code == 200) {
        this.$message({
          message: "注册成功",
          type: "success",
        });
        setTimeout(() => {
          this.$router.push({
            path: "/Login/Login",
            query: {
              TownCode: this.$route.query.TownCode,
            },
          });
        }, 2500);
      } else {
        this.$message({
          message: res.message,
          type: "warning",
          duration: 2000,
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 直接登录
    directLogin(formName) {
      this.$refs[formName].resetFields();
      this.$router.push({
        path: "/ReportLogin/Login",
        query: {
          TownCode: this.$route.query.TownCode,
        },
      });
    },
    // 判断是否点击
    isClick() {
      if (this.checked) {
        this.buttonColor = true;
        this.isTrue = false;
      } else {
        this.buttonColor = false;
        this.isTrue = true;
      }
    },
    disabledButton() {
      if (this.ruleForm.contactTel && this.sendCode) {
        this.disabled = true;
        this.isShow = false;
        this.timer = setInterval(() => {
          this.timeNum--;
          if (this.timeNum == 0) {
            this.disabled = false;
            this.isShow = true;
            this.timeNum = 60;
            clearInterval(this.timer);
          }
        }, 1000);

        let data = {
          tel: this.ruleForm.contactTel,
        };
        this.getPhoneCode(data);
      }
    },
    getPhoneCode(data) {
      ApiTelCode(data).then((res) => {
        if (res.code == 200) {
          // this.ruleForm.telCode = res.result;
          this.$message({
            message: "验证码发送成功",
            type: "success",
          });
        }
      });
    },
    agreement() {},
  },
  watch: {
    reset(val) {
      if (val) {
        this.disabled = this.checked = false;
        this.isShow = true;
        this.timeNum = 60;
        this.buttonColor = false; // 登录按钮颜色
        this.isTrue = true; // 登录按钮是否可用
        clearInterval(this.timer);
        this.resetForm("ruleForm");
      }
    },
  },
  destroyed() {
    if (this.timer) {
      //如果定时器在运行则关闭
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding: 0 47px;
  ::v-deep  .el-radio__label {
    padding-left: 4px;
  }

  ::v-deep  .el-form-item__content {
    line-height: 30px;
  }

  form {
    padding-top: 25px;
  }
  ::v-deep  .el-input__inner {
    height: 46px;
    background: #f5f5f5 !important;
  }
  /* 失去焦点改变背景颜色 */
  ::v-deep  .el-input__inner[inputblur="inputblur"] {
    /* background:#E9F0FD; */
    background: #f5f5f5 !important;
  }

  ::v-deep  .el-form-item__content .button_login {
    width: 100%;
    height: 36px;
    border: 0;
    border-radius: 2px !important;
  }

  ::v-deep  .el-form-item__content .buttonColor {
    background: #3165ff !important;
  }

  ::v-deep  .el-form-item__content {
    margin-bottom: 18px;
    margin-left: 0 !important;
  }

  ::v-deep  .sub_button .el-form-item__content {
    margin-bottom: 15px !important;
    margin-top: 8px;
  }
}

.public_style {
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: #3165ff;
}

.agreement_content {
  ::v-deep  .el-checkbox__label {
    padding-left: 6px;
  }

  ::v-deep  .el-checkbox-group {
    display: inline-block;
  }

  ::v-deep  .el-checkbox__label {
    color: #b6bcc2 !important;
    cursor: default;
  }
}

.registration {
  float: right;
}

.code_txt {
  width: calc(100% - 100px - 10px);
}

.agreement_check {
  ::v-deep  .el-form-item__content {
    margin-bottom: 0;
  }
  ::v-deep  .el-form-item__error {
    margin-top: -15px;
  }
}

.agreement_check .phone_code ::v-deep  .el-button,
.phone_code1 ::v-deep  .el-button {
  width: 100%;
  height: 36px;
  padding-left: 0 !important;
  text-align: center;
  padding-right: 0 !important;
  color: #3165ff;
  border-radius: 2px;
  border: 1px solid #3165ff;
}

.phone_code1 ::v-deep  .el-button {
  color: #ccc;
  border: 1px solid #ccc;
}

.phone_code,
.phone_code1 {
  cursor: pointer;
  width: 100px;
  height: 36px;
  line-height: 36px;
  float: right;
  font-size: 14px;
  color: #3165ff;
}
</style>
